import axios from 'axios';
import qs from 'qs';

import { api, apiSubmit, apiCheckPayment, apiWriteLog, apiGetKeyword, apiWriteLogRedirect } from './api';
import config from '../utils/config';
export const Api = {
    submitCode,
    checkPayment,
    checkPaymentSID,
    writeWaitingLog,
    getSessionKeyword,
    WriteLogRedirect,
};

function submitCode(code) {
    const options = {
        method: 'post',
        headers: {
            'X-API-KEY': config.api_key,
        },
        data: qs.stringify({
            code_voucher: code,
            voucher_type: config.voucher_type,
        }),
        url: api + apiSubmit,
    };

    return axios(options);
}

function checkPayment(code) {
    let form = new FormData();
    form.append('waptoken', code);
    form.append('type', 1);
    const options = {
        method: 'post',
        headers: {
            'X-API-KEY': config.api_key,
        },
        data: form,
        url: api + apiCheckPayment,
    };

    return axios(options);
}

function checkPaymentSID(code) {
    let form = new FormData();
    form.append('subsId', code);
    form.append('type', 2);

    const options = {
        method: 'post',
        headers: {
            'X-API-KEY': config.api_key,
        },
        data: form,
        url: api + apiCheckPayment,
    };

    return axios(options);
}

function writeWaitingLog(waptoken, redirectUrl) {
    const options = {
        method: 'get',
        url: api + apiWriteLog,
        headers: {
            'X-API-KEY': config.api_key,
        },
        params: {
            waptoken: waptoken,
            redirectUrl: redirectUrl,
        },
    };

    return axios(options).catch(function(error) {
        console.log(error);
    });
}

function getSessionKeyword(session) {
    const options = {
        method: 'get',
        url: api + apiGetKeyword,
        headers: {
            'X-API-KEY': config.api_key,
        },
        params: {
            session: session,
            type: 2
        },
        timeout: 2000,
    };
 
    return axios(options);
}

function WriteLogRedirect(defaultUrl, redirectUrl) {
    const options = {
        method: 'get',
        url: api + apiWriteLogRedirect,
        headers: {
            'X-API-KEY': config.api_key,
        },
        params: {
            defaultKeyword: defaultUrl,
            rotationKeyword: redirectUrl,
        },
    };
 
    return axios(options).catch(function(error) {
        console.log(error);
    });
}
